import script from "./leftBar2.vue?vue&type=script&setup=true&lang=js"
export * from "./leftBar2.vue?vue&type=script&setup=true&lang=js"

export default script